(function () {
  const selectors = {
    form: ".shopify-product-form",
    mainSelect: "[name='id']",
    upsellProduct: 'input[id^="upsell-product"]',
  };

  const upsellAddToCartButtons = document.querySelectorAll(
    selectors.upsellProduct
  );

  console.log(upsellAddToCartButtons);

  upsellAddToCartButtons.forEach((el) => {
    el.addEventListener("change", (e) => {
      console.log(e);
      console.log(el);
      if (!el.checked) return;
      handleUpsellClick(el.dataset.variantId);
      el.setAttribute("disabled", "");
    });
  });

  function handleUpsellClick(variantId) {
    console.log("adding to cart", variantId);
    let formData = {
      items: [
        {
          id: parseFloat(variantId),
          quantity: 1,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:refresh", {}));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  document
    .querySelector(`${selectors.form} ${selectors.mainSelect}`)
    .addEventListener("change", (e) => {
      const target = e.target;
      const productHandle = target.dataset.productHandle;
      const variantId = target.value;

      document
        .querySelectorAll(".product--upsell-body")
        .forEach((el) => el.classList.add("loading"));

      fetch(
        `/products/${productHandle}?variant=${variantId}&?section_id=product-template`
      )
        .then((res) => res.text())
        .then((html) => {
          const sectionHTML = new DOMParser().parseFromString(
            html,
            "text/html"
          );
          const sourceUpsell = sectionHTML.body.querySelectorAll(
            ".product--upsell-body"
          );

          const targetUpsell = document.querySelectorAll(
            ".product--upsell-body"
          );

          targetUpsell.forEach((el, index) => {
            el.innerHTML = sourceUpsell[index].innerHTML;
            el.classList.remove("loading");
          });

          const upsellAddToCartButtons = document.querySelectorAll(
            selectors.upsellProduct
          );

          console.log(upsellAddToCartButtons);

          upsellAddToCartButtons.forEach((el) => {
            el.addEventListener("change", (e) => {
              console.log(e);
              console.log(el);
              if (!el.checked) return;
              handleUpsellClick(el.dataset.variantId);
              el.setAttribute("disabled", "");
            });
          });
        });
    });
})();
